import { toDay } from "../charts/charts.utils";

import type {
  GetUserWatchedGraphResponse,
  UserWatchedGraphItem,
} from "@/src/api/StatsAPI.types";

import type { TimelineDatum } from "../charts/charts.types";

export type WatchedMediaKey = "watchedMedia";

export type PlaytimeKey = "playtime";

function buildTimeline<Key extends string>(
  response: Pick<GetUserWatchedGraphResponse, "data"> | undefined,
  toValues: (item: UserWatchedGraphItem) => Record<Key, number>,
): TimelineDatum<Key>[] {
  return (response?.data ?? []).map((item) => ({
    date: toDay(item.date),
    values: toValues(item),
  }));
}

export function buildWatchedMediaTimeline(
  response: Pick<GetUserWatchedGraphResponse, "data"> | undefined,
): TimelineDatum<WatchedMediaKey>[] {
  return buildTimeline(response, (item) => ({
    watchedMedia: item.media_count,
  }));
}

export function buildPlaytimeTimeline(
  response: Pick<GetUserWatchedGraphResponse, "data"> | undefined,
): TimelineDatum<PlaytimeKey>[] {
  return buildTimeline(response, (item) => ({ playtime: item.playtime }));
}
